import React, { useState } from "react";
import { useSelector, useDispatch, shallowEqual, } from "react-redux";
import { InfoWindowF, MarkerF } from '@react-google-maps/api';

//import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
//import Typography from '@mui/material/Typography';

// import patientIcon from '../../assets/patienticon.svg';
// import caregiverIcon from '../../assets/caregiver.svg';
// import medicIcon from '../../assets/medic.svg';
// import { ReactComponent as carecenterIcon } from '../../assets/carecentericon.svg';
// import { ReactComponent as housingIcon } from '../../assets/house.svg';
import carecenterIcon from '../../assets/carecentericon.png';
import housingIcon from '../../assets/house.png';
import futureStop from '../../assets/Future_stop.png'
import currentStop from '../../assets/Current_stop.png'
import pastStop from '../../assets/Past_stop.png'
import coeIcon from '../../assets/coe.png';
import clinicalTrialIcon from '../../assets/clinical_trial.png';
import supportIcon from '../../assets/support_group.png';
import walkIcon from '../../assets/walk.png';
import { activateMarker, getActiveMarkers } from "../../features/activeMarkers";// activateCareCenter, activateWarrior /*} from '../features/activeMarkers'
//import { setPublicPinClicked, getProfileFromID, getAIProfileSummary } from "../../features/dataProcessingSlice"
//import { useEffect } from "react";
//import { GetUserTypePinSVG1 } from '../MessageProfile';
import { ClinicalTrialInfoWindowDetails, CoeInfoWindowDetails, HousingInforWindowDetails, SupportGroupInfoWindowDetails } from "./InfoWindowDetails";
import { useGeInstitutionsQuery } from "../../features/institutionsSlice";
import { CircularProgressCentered } from "../../app/components/sharedcomponents";
import { customIcon, setupMarkerTapAndHold, useZoomIconSync } from "./MMMarkers";
import { Description } from "@mui/icons-material";
import { Condition, condition, coonditionContext } from "../..";
import { useGetClinicalTrialsQuery } from "../../features/clinicalTrials";
import { useIsMobile } from '../../app/IsMobileContext';
import { useEffect, useRef } from 'react';
import { setActivePinModal } from '../../features/utilitySlice';
import { skipToken } from "@reduxjs/toolkit/query";
import { filterSelector } from "../../features/filterSlice";
import { useAgentData } from "../map/MapCircle";


export const InstitutionTypes = ['E', 'S', 'H', "TR1,2,3", "TR4,5", 'WALK']

/** BCAN Walks are event-based and the last event has passed — SUPPRESSED, not removed.
 *  Re-enabling the next walk = refresh the `WALK` institution rows and flip this to true;
 *  every walk code path (icon, info window, filter row, pin label) is left intact.
 *  Read in TWO places, because the filter row and pin visibility are independent:
 *  `ShowMarkerType` below hides the pins, MapFilterMenu hides the filter row.
 *  Walks stay Bladder-Cancer-only when re-enabled — this flag only gates, never widens. */
export const SHOW_BCAN_WALKS = false
export interface MarkerTypeOption { type: string, status: string }
export const GetIntitutionTypePinPNG: (markerTypeVsMarkerTypeOption: string | MarkerTypeOption) => string = (markerTypeVsMarkerTypeOption) => {
  const { type: markerType, status: option } = typeof markerTypeVsMarkerTypeOption === 'object' ? markerTypeVsMarkerTypeOption : { type: markerTypeVsMarkerTypeOption, status: undefined }
  //   var option
  //  if( typeof markerTypeVsMarkerTypeOption === 'object') {
  //   markerType = markerTypeVsMarkerTypeOption.markerType
  //   option = 
  //  } else { 
  //   markerType = markerTypeVsMarkerTypeOption 
  //  }

  return markerType === 'H' ? housingIcon :
    markerType === 'E' ? coeIcon :
      markerType === 'C' ? carecenterIcon :
        markerType === 'S' ? supportIcon :
          markerType === 'TR1,2,3' ? clinicalTrialIcon :
            markerType === 'TR4,5' ? clinicalTrialIcon :
              markerType === 'WALK' ? walkIcon :
                markerType === 'BSTP' ? (option === 'C' ? currentStop : option === 'F' ? futureStop : option === 'P' ? pastStop : currentStop) :
                  carecenterIcon
}

export const isCTCondition = (condition: string) => condition === 'Bladder Cancer' || condition === 'Adult Myositis'

export const ShowMarkerType: (pinType: string, institutionTypesState: any, unknownIsGood: boolean) => boolean = (pinType, institutionTypesState, unknownIsGood) => {
  // Gate walks here rather than via the filter default: "Select All" dispatches
  // showCareCenters(true), which replaces the whole map with the boolean `true` and
  // would otherwise make every type — walks included — visible again.
  if (!SHOW_BCAN_WALKS && pinType === 'WALK') return false
  const ret = typeof institutionTypesState === 'boolean' ? institutionTypesState : (pinType in institutionTypesState ? institutionTypesState[pinType] : unknownIsGood)
  // if( pinType === 'TR'){
  //   console.log( 'TR', ret)
  //   return ret
  // }
  return ret
}

// const activeTRMarkers = (activeMarkers: any): string[] => {
//   return Object.keys(activeMarkers).filter((key: string) => key.startsWith('TR') && activeMarkers[key]);
// }


export const InstitutionMarkers: React.FC<any> = () => {
  const agentData = useAgentData();
  const institutionTypesState = useSelector((state: any) => state.filter.showCareCenters, shallowEqual)
  const unknownIsGood = useSelector((state: any) => state.filter.unknownIsGood)
  const { data: institutionsData, isLoading, isSuccess, isError, error, } = useGeInstitutionsQuery()//agentData ? skipToken : undefined)
  const { condition } = React.useContext<Condition>(coonditionContext);
  //const activeMarkers = useSelector(getActiveMarkers);
  //const activeMarkers = useSelector(filterSelector)
  const arg = isCTCondition(condition) ? ShowMarkerType('TR1,2,3', institutionTypesState, unknownIsGood) ? {
    condition: condition,
    ...condition === "Adult Myositis" ? { addlConditions: ['NCT06284954', 'NCT05869955'] } : {},
    trialPhase: ['1', '2', '3']
  } : skipToken : skipToken
  const { data: clinicalTrials, isLoading: clinicalTrialsIsLoading, isSuccess: clinicalTrialsIsSuccess, isError: clinicalTrialsIsError, error: clinicalTrialsError, } = useGetClinicalTrialsQuery(arg)
  const arg1 = isCTCondition(condition) ? ShowMarkerType('TR4,5', institutionTypesState, unknownIsGood) ? {
    condition: condition,
    ...condition === "Adult Myositis" ? { addlConditions: ['NCT06455449', 'NCT05895786'] } : {},
    trialPhase: ['4', '5']
  } : skipToken : skipToken
  const { data: clinicalTrials1, isLoading: clinicalTrialsIsLoading1, isSuccess: clinicalTrialsIsSuccess1, isError: clinicalTrialsIsError1, error: clinicalTrialsError1, } = useGetClinicalTrialsQuery(arg1)
  if (isLoading)
    return (<CircularProgressCentered />)
  if (isError) {
    const errMsg = 'status' in error ? `Error: ${error.status}` : 'error';
    return <div>{errMsg}</div>;
  }
  const showAllTypes = typeof institutionTypesState === 'boolean' ? institutionTypesState : undefined
  if (!showAllTypes && showAllTypes !== undefined && (!agentData?.institutionPins || !agentData?.institutionPins?.length)) {
    return null
  }

  //const pinType = row.data.type
  //const showMarkerType = typeof institutionTypesState === 'boolean' ? institutionTypesState : (pinType in institutionTypesState ? institutionTypesState[pinType] : unknownIsGood)
  //const institutions = agentData ? agentData.institutionPins : institutionsData
    const institutions =  agentData?.args?.show_objects?agentData?.institutionPins: institutionsData
  return (<>
    {/* {institutions?.map(
      (row: any) => (<InstitutionMarker zoom={zoom} id={-row.id} data={row} key={-row.id} />)
    )
    } */}
    {institutions?.map(
      (row: any) => ( (agentData?.args?.show_objects ||ShowMarkerType(row.type, institutionTypesState, unknownIsGood))  && <InstitutionMarker id={-row.id} data={row} key={-row.id} />)
    )
    }
    {(!agentData?.args?.show_objects &&clinicalTrialsIsSuccess && ShowMarkerType('TR1,2,3', institutionTypesState, unknownIsGood)) && clinicalTrials?.map(
      (row: any) => (<InstitutionMarker id={row.id} data={row} key={row.id} />)
    )
    }
    {(!agentData?.args?.show_objects && clinicalTrialsIsSuccess1 && ShowMarkerType('TR4,5', institutionTypesState, unknownIsGood)) && clinicalTrials1?.map(
      (row: any) => (<InstitutionMarker id={row.id} data={row} key={row.id} />)
    )
    }
  </>
  )
}


const InstitutionMarkerNotMemoized: React.FC<any> = ({ id, data }) => {//{ markerType, lat, lng, name, isInfoWindowOpen = false, animation = null, description = undefined, address = undefined, phone = undefined, href = undefined, id })  =>{
  const markerRef = useRef<any>(null);
  const [infoWindowOpen, setInfoWindowOpen] = useState(false);
  const isMarkerActive = useSelector(
    (state: any) => {
      if (state.activeMarkers?.id === id) {
        return true
      }
      return false
    }

  );

  const dispatch = useDispatch()
  const isMobile = useIsMobile()
  const isMobileRef = useRef(isMobile)
  useEffect(() => { isMobileRef.current = isMobile }, [isMobile])
  const markerType = data.type

  const institutionTypePinPNG = GetIntitutionTypePinPNG(markerType)//markerType === 'H' ? housingIcon : markerType === 'E' ? coeIcon : markerType === 'carecenter' ? carecenterIcon : carecenterIcon

  // Imperatively sync icon size with zoom via native Google Maps event — no React re-renders
  const sizeRef = useZoomIconSync(markerRef, institutionTypePinPNG as string | null)

  function handleMouseOver() {
    if (isMarkerActive) {//activeMarkers.disableHover) {
      return;
    }
    setInfoWindowOpen(true);
    //activateCallBack(id)
  };

  function handleMouseOut() {
    if (isMarkerActive) {//activeMarkers.disableHover) {
      return;
    }
    setInfoWindowOpen(false);
  };

  function handleWindowClose() {
    setInfoWindowOpen(false);
    dispatch(activateMarker({ id: null, disableHover: false }))
  };

  const markerTypeString = typeof markerType === 'string' ? markerType : markerType.type ?? ''

  function onLoad(marker: any) {
    markerRef.current = marker
    const modalData = markerTypeString === 'BSTP'
      ? { ...data, description: `${data.description} of a 3,100 mile eBike ride across the USA to raise money for multiple myeloma research, financial assistance, and awareness.` }
      : data
    setupMarkerTapAndHold(marker, {
      isMobileRef,
      dispatch,
      activateId: id,
      setInfoWindowOpen,
      buildPayload: (c) => ({
        data: modalData, category: 'institution',
        heroInfo: institutionTypePinPNG
          ? { screenX: c.sx, screenY: c.sy, iconUrl: institutionTypePinPNG as string, iconSize: sizeRef.current }
          : undefined,
      }),
      onDesktopClick: () => {
        dispatch(activateMarker({ id: id, disableHover: true }))
        setInfoWindowOpen(false)
      },
    })
  }

  return (
    <MarkerF
      key={`marker-${data.id}`}
      onLoad={onLoad}
      position={{ lat: parseFloat(data.lat), lng: parseFloat(data.lng) }}
      icon={customIcon(institutionTypePinPNG as unknown as string, sizeRef.current)}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      {!isMobile && (isMarkerActive || infoWindowOpen) && (
        <InfoWindowF onCloseClick={handleWindowClose}
          position={{ lat: parseFloat(data.lat), lng: parseFloat(data.lng) }}
          options={{ disableAutoPan: true }}
        >
          <Box>
            {(markerType === 'E') && <CoeInfoWindowDetails data={data} onClose={handleWindowClose} />}
            {(markerType === 'H') && <HousingInforWindowDetails data={data} onClose={handleWindowClose} />}
            {(markerType === 'C') && <CoeInfoWindowDetails data={data} onClose={handleWindowClose} />}
            {(markerType === 'S') && <SupportGroupInfoWindowDetails data={data} onClose={handleWindowClose} />}
            {(markerType === 'WALK') && <SupportGroupInfoWindowDetails data={data} onClose={handleWindowClose} />}
            {(markerTypeString.startsWith('TR')) && <ClinicalTrialInfoWindowDetails data={data} onClose={handleWindowClose} />}
            {((typeof markerType === 'string' && markerType === 'BSTP') || (typeof markerType === 'object' && markerType.type === 'BSTP')) && <SupportGroupInfoWindowDetails onClose={handleWindowClose} data={{ ...data, description: `${data.description} of a 3,100 mile eBike ride across the USA to raise money for multiple myeloma research, financial assistance, and awareness.` }} />}
          </Box>
        </InfoWindowF>
      )}
    </MarkerF>
  );

}
export const InstitutionMarker = React.memo(InstitutionMarkerNotMemoized);




